export const USE_SINGLE_INVOICE_QUERY_KEY = "useSingleInvoiceQuery";
export const USE_INVOICE_COLLECTION_QUERY_KEY = "useInvoiceCollectionQuery";
